import React from "react";

/**
 * Shared nav actions for Plans marketing sections.
 */
export default function SiteNavActions({
  onNav,
  btnClassName,
  downloadRowClassName,
}) {
  return (
    <>
      <button type="button" className={btnClassName} onClick={() => onNav("plans")}>
        Plans
      </button>
      <button type="button" className={btnClassName} onClick={() => onNav("feed")}>
        Feed
      </button>
      <button type="button" className={btnClassName} onClick={() => onNav("how-it-works")}>
        How it works
      </button>
      <div className={downloadRowClassName}>
        <button type="button" className={btnClassName} onClick={() => onNav("download")}>
          Download App
        </button>
      </div>
    </>
  );
}
